var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import StepContent from "./StepContent";
var Step = function (_a) {
    var label = _a.label, _b = _a.labelWeight, labelWeight = _b === void 0 ? "regular" : _b, value = _a.value;
    return (_jsxs("div", { children: [_jsx(StepContent, __assign({ weight: labelWeight, "data-cy": "label" }, { children: label })), _jsx(StepContent, __assign({ weight: "light", "data-cy": "value" }, { children: value }))] }));
};
export default Step;
//# sourceMappingURL=Step.js.map